import { useState } from 'react'
import classNames from 'classnames'

import FooterListItemPage from './FooterListItemPage'
import FooterListItemUrl from './FooterListItemUrl'
import IconHref from './IconHref'
import { InfoStrip } from './FooterInfoStrip'

import logo from 'shared//assets/logoFooter.svg'

import styles from '../styles/footerResponsive.module.scss'

const FooterListTitle = ({ title, isListOpen = false, onClick }) => {
    const titleClass = classNames(styles.footerResponsiveTitleRow, isListOpen && styles.active)

    return (
        <div className={titleClass} onClick={onClick}>
            <h6>
                <a>{title}</a>
            </h6>
            <span className={styles.indicator} />
        </div>
    )
}

const FooterListItem = props => {
    if (props.layout === 'link')
        if (props.type === 'page') {
            return <FooterListItemPage {...props} />
        } else if (['url', 'page-slug'].includes(props.type)) {
            return <FooterListItemUrl {...props} />
        }

    return null
}

const FooterList = ({ itemIndex, title, items, isListOpen, onToggleListItem }) => (
    <ul className={styles.footerResponsiveList}>
        <FooterListTitle title={title} isListOpen={isListOpen} onClick={onToggleListItem} itemIndex={itemIndex} />
        {isListOpen && items.map((item, index) => <FooterListItem key={index} {...item} />)}
    </ul>
)

const TYPE_LINKEDIN = 'linkedin'
const TYPE_TWITTER = 'twitter'
const TYPE_X = 'x'
const TYPE_FACEBOOK = 'facebook'
const TYPE_INSTAGRAM = 'instagram'
const TYPE_VIMEO = 'vimeo'
const TYPE_APPSTORE = 'appstore'
const TYPE_GOOGLEPLAY = 'googleplay'

const SocialIconHref = ({ label, type, url }) => {
    let iconPath
    switch (type) {
        case TYPE_LINKEDIN:
            iconPath = require('../../shared/icons/ic-in.svg')
            break
        case TYPE_TWITTER:
            iconPath = require('../../shared/icons/ic-tw.svg')
            break
        case TYPE_X:
            iconPath = require('../../shared/icons/ic-x.svg')
            break
        case TYPE_FACEBOOK:
            iconPath = require('../../shared/icons/ic-facebook.svg')
            break
        case TYPE_INSTAGRAM:
            iconPath = require('../../shared/icons/ic-instagram.svg')
            break
        case TYPE_VIMEO:
            iconPath = require('../../shared/icons/ic-vimeo.svg')
            break
        case TYPE_APPSTORE:
            iconPath = require('../../shared/icons/ic-appstore.svg')
            break
        case TYPE_GOOGLEPLAY:
            iconPath = require('../../shared/icons/ic-googleplay.svg')
            break
    }

    if (iconPath) {
        return <IconHref alt={label} iconPath={iconPath} iconActivePath={iconPath} url={url} />
    }

    return (
        <a target="__blank" href={url}>
            {label}
        </a>
    )
}

const SocialContainer = ({ title, items = [] }) => (
    <div className={styles.footerResponsiveSocialContainer}>
        <h6 className={styles.footerResponsiveSocialTitle}>
            <a>{title}</a>
        </h6>
        <div className={styles.footerResponsiveSocialList}>
            {items.map((item, index) => {
                if (item.layout === 'social_link') {
                    return <SocialIconHref key={index} {...item} />
                }

                if (item.layout === 'link' && item.type === 'page') {
                    return (
                        <Link key={index} to={item.page}>
                            {item.label}
                        </Link>
                    )
                }

                if (item.layout === 'link' && item.type === 'url') {
                    return (
                        <a key={index} href={item.url}>
                            {item.label}
                        </a>
                    )
                }
            })}
        </div>
    </div>
)

const FooterResponsive = ({ columns, brandLogo }) => {
    const [openIndices, setOpenIndices] = useState([0])

    const onToggleListItem = index => {
        const indices = openIndices.slice(0)
        if (indices.indexOf(index) !== -1) {
            indices.splice(indices.indexOf(index), 1)
            setOpenIndices(indices)
        } else {
            indices.push(index)
            setOpenIndices(indices)
        }
    }

    const apiSocialTitle = 'follow us'
    const regularColumns = columns.reduce((acc, val) => {
        if (val.title && val.title.toLowerCase() !== apiSocialTitle) acc.push(val)

        return acc
    }, [])

    const socialColumn = columns.reduce((acc, val) => {
        if (val.title && val.title.toLowerCase() === apiSocialTitle) acc = val

        return acc
    }, [])

    return (
        <div className={styles.footerContainerResponsive}>
            <div className={styles.footerContainerResponsiveTop}>
                <div className={classNames('container', styles.footerResponsiveContent)}>
                    <div className={styles.footerRegularLists}>
                        {regularColumns.map((column, index) => (
                            <FooterList
                                itemIndex={index}
                                key={index}
                                isListOpen={openIndices.includes(index)}
                                onToggleListItem={() => onToggleListItem(index)}
                                {...column}
                            />
                        ))}
                    </div>
                    <div className={styles.separatorLine} />
                    {socialColumn && <SocialContainer {...socialColumn} />}
                </div>
            </div>
            <div className={styles.footerContainerResponsiveBottom}>
                <div className={classNames('container', styles.footerResponsiveContent)}>
                    <div className={styles.footerResponsiveInfoStrip}>
                        <img src={brandLogo || logo} alt="IndigoNeo" />
                        <div className={styles.footerResponsiveInfoText}>
                            <InfoStrip />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterResponsive
